import { z } from 'zod'
import { validateRequiredDescription } from '../utils/description-validation'

const importDescriptionSchema = z.string().transform((value, ctx) => {
  const validation = validateRequiredDescription(value, { maxChars: 1000 })
  if (!validation.ok) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: validation.error })
    return z.NEVER
  }
  return validation.value
})

/** Schema for ZIP-based import (Obsidian/Notion) */
export const startImportSchema = z.object({
  source: z.enum(['obsidian', 'notion']),
  description: importDescriptionSchema,
  targetFolderId: z.string().optional(),
})

/** Schema for Lark API-based import */
export const startLarkImportSchema = z.object({
  token: z.string().min(1),
  description: importDescriptionSchema,
  spaceId: z.string().optional(),
  targetFolderId: z.string().optional(),
})
